import React from "react";

// import { useHistory /*, useRouteMatch*/ } from "react-router";
import { Route, Switch } from "react-router-dom";

import LiveDataPanelContainer from "./livedata-panel-container";
import PanelCollectionMapContainer from "./panel-collection-map-container";
import PanelCollectionTableContainer from "./panel-collection-table-container";

interface Props {}

// TODO hooks and use useRouteMatch as in https://reacttraining.com/blog/react-router-v5-1/#useroutematch
function Routes(props: Props) {
  // const location = useLocation();
  // const history = useHistory();
  return (
    <>
      <Switch>
        <Route path="/livedata/collections/:panelCollectionName/panel">
          <LiveDataPanelContainer />
        </Route>
        <Route path="/livedata/collections/:panelCollectionName/list">
          <PanelCollectionTableContainer />
        </Route>
        <Route path="/livedata/collections/:panelCollectionName/map">
          <PanelCollectionMapContainer />
        </Route>
      </Switch>
    </>
  );
}
export default Routes;
